import InstallAppTuto from 'components/install-app-tuto/InstallAppTuto';
import React from 'react';

export interface QuestionnaireInstallAppProps {
  isAndroid?: boolean;
  isIOS?: boolean;
}
const QuestionnaireInstallApp: React.FC<QuestionnaireInstallAppProps> = ({ isAndroid, isIOS }) => {
  return <InstallAppTuto isAndroid={isAndroid} isIOS={isIOS} />;
};

export default QuestionnaireInstallApp;
